 (function($) {
 	$(document).on('click', '.loadmore', function (e) {
        e.preventDefault();
        var $el = $(this),
            link = $el.attr('href');
         var $count = $(this).data('count');
        if ($el.attr('disabled'))
            return;
        $el.addClass('loading').attr('disabled', true);
        $el.find('span').html('Loading...')
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").append($(this).find("#loadmorecontainer").html());
            $el.parents('.load-more').removeAttr('disabled').remove();
            if($count){
	        	$('.blog-list-filter-bottom span').html($count);
	        }
	        var waypoints = $('.loadmore').waypoint(function(direction) {
		  		if (direction === 'down') {
			    	$(this.element).trigger('click');
			    	this.destroy();
			    }
			}, { offset: '100%' });
        });               
    });
    $(document).on('click', '.nav-toggle', function (e) {
        e.preventDefault();
        if($('html').hasClass('uc-nav-open')){
        	$('html').removeClass('uc-nav-open');
        	$(this).removeClass('open');
        }else{
        	$('html').toggleClass('nav-open');
	        $(this).toggleClass('open');
	        if($(this).hasClass('open')){
	        	$('.slide-navigation-top .menu li').removeClass('open');
	        	$('.bck-btn').remove();
	        }
        }
        
    });
    $(document).on('click', '.use-case-menu-mobile', function (e) {
        e.preventDefault();
        $('html').addClass('uc-nav-open');
        $('.nav-toggle').addClass('open');
    });
    
    $(document).on('click', '.slide-navigation-top .menu > li.menu-item-has-children > a', function (e) {
        e.preventDefault();
        $(this).parent().addClass('open');
        $('.site-branding').prepend('<span class="bck-btn"><i class="icon-angle-left"></i> Back</span>');
    });

    $(document).on('click', '.bck-btn', function (e) {
        e.preventDefault();
        $('.slide-navigation-top li.menu-item-has-children').removeClass('open');
        $(this).remove();
    });
    /*$(document).on('click', '.use-case-navigation-item > ul > li > a', function (e) {
        e.preventDefault();
        $(this).toggleClass('active').next().slideToggle();
    });*/

 	$('.home-banner-slider-in').slick({
	    dots: true,
	    infinite: true,
	    autoplay: true,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: false,
  	});
  	$('.home-testimonial-carousel').slick({
	    dots: true,
	    infinite: true,
	    autoplay: true,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: true,
	    prevArrow: '<span class="slick-prev"><i class="icon-arrow-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-arrow-right"></span>',
  	});
  	$('.featured-blog-list').slick({
	    dots: true,
	    infinite: true,
	    autoplay: true,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: true,
	    prevArrow: '<span class="slick-prev"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-angle-right"></span>',
  		customPaging: function (slider, i) {
        //FYI just have a look at the object to find available information
        //press f12 to access the console in most browsers
        //you could also debug or look in the source
        console.log(slider);
        return  (i + 1) + '/' + slider.slideCount;
    }
  	});
  	$('.testimonial-carousel').slick({
	    dots: true,
	    infinite: true,
	    autoplay: false,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: false,
	    prevArrow: '<span class="slick-prev"><i class="icon-arrow-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-arrow-right"></span>',
  	});
  	$('.company-logo-carousel').slick({
	    dots: true,
	    infinite: true,
	    autoplay: false,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: true,
	    slidesToShow: 7,
	    slidesToScroll: 7,
	    prevArrow: '<span class="slick-prev"><i class="icon-arrow-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-arrow-right"></span>',
  		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 5,
		        slidesToScroll: 5,
		      }
		    },
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 4,
		        slidesToScroll: 4
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3
		      }
		    },
		    {
		      breakpoint: 540,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    }
		  ]
  	});
  	$testi_carousel = $('.home-testimonial-carousel');
  	$testi_carousel.on('init', function(event, slick){
	  slideCount = slick.slideCount;
	  setCurrentSlideNumber(slick.currentSlide);
	});

	$testi_carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
	  setCurrentSlideNumber(nextSlide);
	});
	$('.g2-reviews-cl').slick({
	    dots: true,
	    infinite: true,
	    autoplay: false,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: true,
	    slidesToShow: 3,
	    slidesToScroll: 3,
	    prevArrow: '<span class="slick-prev"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-angle-right"></span>',
  		responsive: [
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 650,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		  ]
  	});

  	$('.comparison-items').slick({
	    dots: true,
	    infinite: true,
	    autoplay: false,
	    speed: 800,
	    autoplaySpeed: 4000,
	    arrows: true,
	    prevArrow: '<span class="slick-prev"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next"><i class="icon-angle-right"></span>',
  		responsive: [
  			{
		      breakpoint: 992,
		      settings: {
		        arrows: false
		      }
		    }
		   ]
  	});


	function setCurrentSlideNumber(currentSlide) {
	  var $el = $('.slide-count-wrap').find('.current');
	  $el.text(currentSlide + 1);
	}
  	$('.video-popup').magnificPopup({
	    type: 'iframe',
	    iframe: {
	          markup: '<div class="mfp-iframe-scaler">'+
	                  '<div class="mfp-close"></div>'+
	                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
	                  '</div>', 
	          patterns: {
	              youtube: {
	                  index: 'youtube.com/', 
	                  id: 'v=', 
	                  src: '//www.youtube.com/embed/%id%?autoplay=1' 
	              }
	           },
	           srcAction: 'iframe_src', 
	       },
	    callbacks: {
	        open: function(el) {
	          $('html').addClass('mfp-cs-open');
	        },
	    }
	});

	$('.faq-item h3').click(function() {
		$('.faq-item h3').removeClass('on');
		$('.faq-item-content').slideUp('normal');
		if($(this).next().is(':hidden') == true) {
			$(this).addClass('on');
			$(this).next().slideDown('normal');
		}
	});
	$('.count-up span').counterUp({
        delay: 10,
        time: 1000
    });
    $('.popup-trigger').magnificPopup({
        type: 'inline',
    });
    $('.demo-popup').magnificPopup({
        type: 'inline',
        callbacks: {
		    open: function(el) {
		      $('.demo-for-input input').val(this._lastFocusedEl.attributes["data-demo"].nodeValue);
		    },
	  }
    });
    
    $('a.scroll-to').bind('click', function(event) {
	    var $anchor = $(this);
	    $('html, body').stop().animate({
	        scrollTop: $($anchor.attr('href')).offset().top
	    }, 700);
	    event.preventDefault();
	});
	/*$('.c-to-go a').bind('click', function(event) {
	    var $anchor = $(this);
	    $('html, body').stop().animate({
	        scrollTop: $($anchor.attr('href')).offset().top - 83
	    }, 700);
	    $('html').removeClass('uc-nav-open')
	    event.preventDefault();
	});*/
	$('.privacy-policy-option-list').on('change', function(event) {
	    var $anchor = this.value;
	    $('html, body').stop().animate({
	        scrollTop: $($anchor).offset().top - 70
	    }, 700);
	    event.preventDefault();
	});
	$('.privacy-policy-list a').bind('click', function(event) {
	    var $anchor = $(this);
	    $('.privacy-policy-list li').removeClass('active');
	    $(this).parent().addClass('active');
	    $('html, body').stop().animate({
	        scrollTop: $($anchor.attr('href')).offset().top
	    }, 700);
	    event.preventDefault();
	});
	$('.floating-sidebar').stickySidebar({
	    topSpacing: 20,
	    bottomSpacing: 0
	});
	$(window).on('scroll', function(e){
		if($('.privacy-policy-option-select').length){
			var Spos = $(this).scrollTop(),
				Pos = $('.privacy-policy-option-select').offset().top;
			if(Spos >= Pos){
				$('.privacy-policy-option-select').addClass('floating');
			}else{
				$('.privacy-policy-option-select').removeClass('floating');
			}
		}
		if($('.site-footer-floating').length){
			var ST = $(this).scrollTop();
			var FH = $('.site-footer').outerHeight();
			var FT = $('.site-footer').offset().top;
			var WH = $(window).outerHeight();
			if(ST >= FT-WH){
				$('.site-footer-floating').addClass('footer-hidden');
			}else{
				$('.site-footer-floating').removeClass('footer-hidden');
			}
		}
		if($('.product-features-section').length){
			var WH = $(this).outerHeight();
			var ST = $(this).scrollTop();
			$('.product-features-section').each(function(i){
				
				var OT = $(this).offset().top;
				var PH = $(this).outerHeight();
				var IH = $(this).find('.product-features-sticky-item').outerHeight();
				
				if(ST>=OT-90){
					if(ST>OT-90 && ST<OT+PH-IH-90){
						$(this).find('.product-features-sticky').addClass('sticky').css('top', '90px');
						
					}else{
						$(this).find('.product-features-sticky').removeClass('sticky').css('top', PH-IH);
					}				
				}else{
					$(this).find('.product-features-sticky').removeClass('sticky').css('top', '0');
				}
				$(this).find('.product-features-item').each(function(i){
					var OTN = $(this).offset().top;
					var IHN = $(this).outerHeight();
					var OBN = OTN+IHN;
					var offset = 350;
					var item = $(this).data('img');
					if(ST>=OT-90){
						if(ST>OTN-offset && ST<OBN-offset){
							$('.product-features-sticky-item').removeClass('active');
							$(item).addClass('active');
							//console.log(ST+'  -  '+(OTN-offset)+'  -  '+(OBN-offset));
							//console.log(item);
						}
					}else{
						/*$('.product-features-sticky-item').removeClass('active');
						$('.product-features-sticky-item').first().addClass('active');*/
					}
				});
			});
		}
	});
	$(document).on('change','.gf-file-input input[type="file"]', function() {

		var $el = $(this).parents('.gf-file-input'),
			size = this.files[0].size,
			$val = this.files[0].name,
			sizeKB = Math.round(size/1000);
		$el.addClass('file-selected');
		$el.find('.gfield_description').hide();
		$el.find('.gfield_label').hide();
		$el.find('.gfield_description').after('<div class="gf-selected-file-size"><span>'+ sizeKB +' KB</span><a href="#">Delete</a></div>');
		$el.find('.gfield_label').after('<div class="gf-selected-file-value">'+ $val +'</div>');

	});
	/*$('.gform_wrapper form').submit(function(){
		if($('.gf-file-input input[type="file"]').val()){
			$( '.gf-file-input input[type="file"]' ).each(function() {
			  var $elm = $('.gf-file-input input[type="file"]'),
					$el = $(this).parents('.gf-file-input');
					size = this.files[0].size,
					$val = this.files[0].name,
					sizeKB = Math.round(size/1000);
					console.log(this.files[0]);
				$el.addClass('file-selected');
				$el.find('.gfield_description').hide();
				$el.find('.gfield_label').hide();
				$el.find('.gfield_description').after('<div class="gf-selected-file-size"><span>'+ sizeKB +' KB</span><a href="#">Delete</a></div>');
				$el.find('.gfield_label').after('<div class="gf-selected-file-value">'+ $val +'</div>');
			});
			
		}
	});*/
	 $(document).on('gform_post_render', function(data){
 
       //console.log(data);
    });
	$(document).on('click', '.gf-selected-file-size a', function(e){
		e.preventDefault();
		var $elm = $(this).parents('.gf-file-input'),
			$el = $(this).parents('.gf-file-input').find('.ginput_container_fileupload');
		$elm.find('.gfield_description').show();
		$elm.find('.gfield_label').show();
		$elm.find('.gf-selected-file-size').hide();
		$elm.find('.gf-selected-file-value').hide();
		$elm.removeClass('file-selected');
		$el.wrap('<form>').closest('form').get(0).reset();
   		$el.unwrap();
   		alert('ok');
	});

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = 40;
	var navbarHeightP = $('.site-header-in').outerHeight() + 50;

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 50);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;
	    
	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeightP){
	        // Scroll Down
	        $('header').removeClass('nav-down').addClass('nav-up');
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            $('header').removeClass('nav-up').addClass('nav-down');
	        }
	    }
	    if(st < navbarHeightP){
			$('header').removeClass('nav-up nav-down');
	    }
	    if(st>navbarHeight){
	    	$('header').addClass('floating');
	    }else{
	    	$('header').removeClass('floating');
	    }
	    
	    lastScrollTop = st;
	}

	/**
      Share popup window
    **/
     var popupCenter = function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 3) - (h / 3)) + dualScreenTop;

        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
          newWindow.focus();
        }
      };
    $(document).on( "click", '.share-popup', function(e) {
        var _this = $(this);
        popupCenter(_this.attr('href'), _this.find('.text').html(), 580, 470);
        e.preventDefault();
      });
	var waypoints = $('.loadmore').waypoint(function(direction) {
  		if (direction === 'down') {
	    	$(this.element).trigger('click');
	    	this.destroy();
	    }
	}, { offset: '100%' });

	$('.tab-list a').click(function(){
		$(this).parents('.tab-list').find('li').removeClass('active');
		$(this).parent().addClass('active');
		var currentTab = $(this).attr('href');
		var tgt = $(this).parents('.tab-list').data('tgt');
		//$(this).parents('.tab-list').next().find('.tab-item').hide();
		//$('div.tab-item').hide();
		$(tgt+' > .tab-item').hide();
		$(currentTab).show();
		return false;
	});
	
	$(document).on('mouseover', '.main-navigation ul.menu > li.menu-item-has-children', function(e){
	  $('body').addClass('nav-over');
	});
	$(document).on('mouseout', '.main-navigation ul.menu > li.menu-item-has-children', function(e){
	  $('body').removeClass('nav-over');
	});
	if (window.location.href.indexOf("seehowitworks") > -1) {
		$('#how-it-works')[0].click();
	}
	// scroll spy starts

  var lastId,
    topMenu = $(".use-case-list-main ul.active"),
    topMenuHeight = $(".site-header").outerHeight(),
    stickyMenuHeight = 0,
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });
    var menuH = topMenu.outerHeight();
    if($('.solution-navigation').length){
      var stickyMenuHeight = $('.solution-navigation-in').outerHeight();
    }

  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight-stickyMenuHeight;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

// Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight+menuH+stickyMenuHeight;
     
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
       if ($(this).offset().top < fromTop)
         return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems
           .removeClass("active")
           .end().filter("[href='#"+id+"']").addClass("active");
        $('html').removeClass('uc-nav-open');
     }                   
  });

  //Scrolll spy ends
  if(readCookie('bpoGPTPopupClosed')){
	  
	}else{
		if($('.chat-gpt-popup-tgr').length){
			var idleTime = 0;
			var idleInterval = setInterval(function(){ 
		    	if(idleTime >= 10){
			       $('.chat-gpt-popup-tgr')[0].click();
			       idleTime = 0;
			    }else{ 
			       idleTime++;
			    } 
		   	}, 1000); 

			$(this).mousemove(function (e) {
				idleTime = 0;
			});

			$(this).keypress(function (e) {
				idleTime = 0;
			});
		}
	}


      function createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }
    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }
    $('.chat-gpt-popup-tgr').magnificPopup({
        type: 'inline',
        callbacks: {
		    close: function(el) {
		      createCookie('bpoGPTPopupClosed','1',10);
		      location.reload();
		    },
	  }
    });
    $(document).on('click','.chat-gpt-modal-close', function(){
    	createCookie('bpoGPTPopupClosed','1',10);
    });
    $(document).on('click','.filter-more', function(e){
    	$('.blog-list-filter').addClass('expanded')
    });
    $(document).on('click','.filter-less', function(e){
    	e.preventDefault();
    	$('.blog-list-filter').removeClass('expanded')
    });
    if($('.event-video-rec-tsc').length){
    	if($(window).width() > 768){
		    $(window).on("resize", function () {
		    	var Hieght = $('.event-head').outerHeight();
			    $('.event-video-rec-tsc').css('height', Hieght-50);
			}).resize();
		}else{
			$('.event-video-rec-tsc').css('height', 'auto');
		}
	}

})(jQuery);